/** A workspace as other records reference it: enough to name it and draw its avatar. */
export default class WorkspaceLite {
  readonly id: string;

  readonly name: string;

  readonly avatarColor: string | null;

  readonly avatarIcon: string | null;

  readonly avatarEmoji: string | null;

  readonly avatarInitials: string | null;

  constructor(input: {
    id: string;
    name: string;
    avatarColor?: string | null;
    avatarIcon?: string | null;
    avatarEmoji?: string | null;
    avatarInitials?: string | null;
  }) {
    this.id = input.id;
    this.name = input.name;
    this.avatarColor = input.avatarColor ?? null;
    this.avatarIcon = input.avatarIcon ?? null;
    this.avatarEmoji = input.avatarEmoji ?? null;
    this.avatarInitials = input.avatarInitials ?? null;
  }
}
